import {CaseStyle} from "kryo";
import {ArrayType} from "kryo/array";
import {$Boolean} from "kryo/boolean";
import {RecordIoType, RecordType} from "kryo/record";
import {Ucs2StringType} from "kryo/ucs2-string";

export type MonthDay = string;

export const $MonthDay: Ucs2StringType = new Ucs2StringType({maxLength: 5});

export interface DailyRunSummary {
  date: MonthDay;
  hasVictory: boolean;
}

export const $DailyRunSummary: RecordIoType<DailyRunSummary> = new RecordType<DailyRunSummary>({
  properties: {
    date: {type: $MonthDay},
    hasVictory: {type: $Boolean},
  },
  changeCase: CaseStyle.SnakeCase,
});

export interface DailyRunSummaryList {
  byDay: DailyRunSummary[];
}

export const $DailyRunSummaryList: RecordIoType<DailyRunSummaryList> = new RecordType<DailyRunSummaryList>({
  properties: {
    byDay: {type: new ArrayType({itemType: $DailyRunSummary, maxLength: 366})},
  },
  changeCase: CaseStyle.SnakeCase,
});
